export const sourceColoumns = [
    {
        id: 1,
        name: "Source Coloumn-1",
    },
    {
        id: 2,
        name: "Source Coloumn-2",
    },
    {
        id: 3,
        name: "Source Coloumn-3",
    },
    {
        id: 4,
        name: "Source Coloumn-4",
    },
    {
        id: 5,
        name: "Source Coloumn-5",
    },
    {
        id: 6,
        name: "Source Coloumn-6",
    },
    {
        id: 7,
        name: "Source Coloumn-7",
    }
]

